import React, { useState } from 'react'
import style from "../SupplierManagement.module.css";
import { searchPro } from './widgets/searchProducts';
import axios from 'axios';
import { Supplier_api } from '../../../Apiconfig';

const AddSupplierOrder = (props) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isManuallyAreaVisible, setIsManuallyAreaVisible] = useState(false);

  const [manualProduct, setManualProduct] = useState({
    product_name: "",
    buy_price: 0,
    product_quantity: 1,
  });

  // Handle manual product details
  const handleManualProductDetails = (e) => {
    const { name, value } = e.target;
    setManualProduct({
      ...manualProduct,
      [name]: value,
    });
  };

  // Add manual product in order list
  const addManualProductToOrderList = (e) => {
    e.preventDefault(); // Prevent the default form submission behavior

    // Add the manualProduct to the orderList
    setOrderList([...orderList, manualProduct]);

    // Reset the manualProduct state
    setManualProduct({
      product_name: "",
      buy_price: 0,
      product_quantity: 1,
    });
  };

  // Product List
  const [productList, setProductList] = useState([]);
  // Order List
  const [orderList, setOrderList] = useState([]);

  // Function to add product in order list
  const addToOrderList = (product) => {
    setOrderList((prevOrderList) => {
      // Check if the product is already in the orderList
      const exists = prevOrderList.some((item) => item.id === product.id);
      if (!exists) {
        // Create a copy of the product with product_quantity set to 1
        const productWithQuantityOne = { ...product, product_quantity: 1 };
        return [...prevOrderList, productWithQuantityOne]; // Add new product with updated quantity
      }
      return prevOrderList; // Return unchanged if product already exists
    });
  };

  // Function to change quantity of order list items
  const handleQuantityChange = (index, newQuantity) => {
    setOrderList((prevOrderList) => {
      const updatedOrderList = [...prevOrderList];
      updatedOrderList[index] = {
        ...updatedOrderList[index],
        product_quantity: Math.max(1, parseInt(newQuantity, 10) || 1), // Ensure quantity is at least 1
      };
      return updatedOrderList;
    });
  };

  // Function to remove product from order list
  const removeFromOrderList = (id) => {
    setOrderList((prevOrderList) => prevOrderList.filter((item) => item.id !== id));
  };

  // Function to show the modal
  const showModal = () => {
    setIsManuallyAreaVisible(false);
    setIsModalVisible(true);
  };

  // Function to close the modal
  const closeModal = () => {
    setIsModalVisible(false);
  };

  // Show Product List
  const showProducts = async (searchText) => {
    if (searchText.length >= 3) {
      const products = await searchPro(searchText); // Await the data from searchPro
      setProductList(products || []); // Update the state with the resolved data or an empty array
      showModal();
    } else {
      setProductList([]); // Clear the product list if the search text is too short
      closeModal();
    }
  };

  // Add order
  const addOrder = async () => {
    if (orderList.length > 0) {
      const payload = {
        orderList,
        supplierID: props.supplierID,
      };
      try {
        const response = await axios.post(
          `${Supplier_api}addOrder.php`,
          payload,
          {
            withCredentials: true,
          }
        );
        if (response.data.success) {
          setOrderList([]);
          alert(response.data.message);
        } else {
          alert("Error: " + response.data.message);
        }
      } catch (error) {
        console.error("Error adding supplier order:", error);
        alert("An error occurred while adding the supplier order.");
      }
    } else {
      alert("Oreder list is empty");
    }
  };

  return (

    <div className="modal fade" data-bs-backdrop="static" data-bs-keyboard="false" id="addSupplierOrder" tabindex="-1" aria-labelledby="addSupplierOrderLabel" aria-hidden="true">
      <div className={`modal-dialog modal-dialog-centered ${style.addSupplierOrderModal}`}>
        <div className="modal-content">
          <div className="modal-header">
            <h1 className={`modal-title fs-5 ${style.modalHeading}`} id="addSupplierOrderLabel"><i className="fa-solid fa-plus"></i> Add Order</h1>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div className={`modal-body ${style.addOrderSection}`}>

            {/* Add Order */}
            <div className="row align-items-center justify-content-between mb-2">

              <div className="col">
                <div className={`input-group input-group-sm ${style.searchFieldGroup}`}>
                  <span className={`input-group-text ${style.searchFieldPrefix}`} id="basic-addon1"><i className="fa-solid fa-magnifying-glass"></i></span>
                  <input
                    type="search"
                    name="searchProducts"
                    placeholder="SEARCH PRODUCT"
                    className={`form-control ${style.searchField}`}
                    onInput={(e) => showProducts(e.target.value)}
                  // onBlur={closeModal} // Call closeModal when the input loses focus
                  // onClick={(e) => showProducts(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-auto">
                <button onClick={() => { setIsModalVisible(false); setIsManuallyAreaVisible(!isManuallyAreaVisible) }} className={`rounded-pill ${style.common_btn}`}><i className="fa-solid fa-plus"></i> Add Manually</button>
              </div>

            </div>

            {isModalVisible && (
              <div className="row mb-3">
                <div className="col-md-12">
                  <div className={style.custom_modal_overlay} onClick={closeModal}>
                    <div
                      className={style.custom_modal}
                      onClick={(e) => e.stopPropagation()} // Prevent overlay click from closing modal
                    >
                      <div className={style.custom_modal_body}>
                        <div className={style.listTitleSection}>
                          <h6 className={`ms-2 mt-2 ${style.listTitle}`}>Product List</h6>
                          <hr className='m-0' />
                        </div>
                        <table className={`${style.orderTable} table table-bordered table-striped table-hover align-middle m-0`}>
                          <thead>
                            <tr>
                              <th scope="col">Product Name</th>
                              <th scope="col">Hindi Name</th>
                              <th scope="col">Local Name</th>
                              <th scope="col">Available Quantity</th>
                            </tr>
                          </thead>
                          <tbody>

                            {productList.length > 0 ? (
                              productList.map((product) => (
                                <tr
                                  key={product.id}
                                  onClick={() => addToOrderList(product)}
                                >
                                  <td>{product.product_name}</td>
                                  <td>{product.hindi_name}</td>
                                  <td>{product.local_name}</td>
                                  <td>{product.product_quantity}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={5} className={style.emptyListText}>PRODUCT NOT FOUND</td>
                              </tr>
                            )}

                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isManuallyAreaVisible && (
              <div className="row mb-3">
                <div className={style.custom_modal_overlay} onClick={closeModal}>
                  <div
                    className={style.manual_modal}
                    onClick={(e) => e.stopPropagation()} // Prevent overlay click from closing modal
                  >
                    <div className={style.custom_modal_body}>
                      <div className={style.listTitleSection}>
                        <h6 className={`ms-2 mt-2 ${style.listTitle}`}>Add Product Manually</h6>
                        <hr className='m-0' />
                      </div>

                      <form onSubmit={addManualProductToOrderList} className="row m-0 py-2 align-items-center">
                        <div className="col-md-3">
                          <div className="form-floating">
                            <input
                              type="text"
                              id='Product_Name'
                              placeholder='Product Name'
                              className="form-control form-control-sm"
                              name='product_name'
                              value={manualProduct.product_name}
                              onChange={handleManualProductDetails}
                              required
                            />
                            <label for="Product_Name">Product Name</label>
                          </div>
                        </div>
                        <div className="col-md-3 mb-2">
                          <div className="form-floating">
                            <input
                              type="number"
                              id='Estimated_Price'
                              placeholder='Estimated Price'
                              className="form-control form-control-sm"
                              name='buy_price'
                              value={manualProduct.buy_price}
                              onChange={handleManualProductDetails}
                              required
                            />
                            <label for="Estimated_Price">Estimated Price</label>
                          </div>
                        </div>
                        <div className="col-md-3 mb-2">
                          <div className="form-floating">
                            <input
                              type="number"
                              id='Quantity'
                              placeholder='Quantity'
                              className="form-control form-control-sm"
                              name='product_quantity'
                              value={manualProduct.product_quantity}
                              onChange={handleManualProductDetails}
                              required
                            />
                            <label for="Quantity">Quantity</label>
                          </div>
                        </div>
                        <div className="col-md-3 mb-2">
                          <button type='submit' className={`${style.addManualProductBtn}`}><i className="fa-solid fa-plus"></i> ADD</button>
                        </div>
                      </form>

                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="row mb-3">
              <div className="col-12">
                <div className={style.orderListSection}>
                  <div className={style.listTitleSection}>
                    <h6 className={`ms-2 mt-2 ${style.listTitle}`}>Order List</h6>
                    <hr className='m-0' />
                  </div>
                  <table className={`${style.orderTable} table table-bordered table-striped align-middle m-0`}>
                    <thead>
                      <tr>
                        <th scope="col">Product Name</th>
                        <th scope="col">Estimated Price</th>
                        <th scope="col">Quantity</th>
                        <th scope="col">Delete</th>
                        <th scope="col">Estimated Total</th>
                      </tr>
                    </thead>
                    <tbody>

                      {orderList.length > 0 ? (
                        orderList.map((orderItem, index) => (
                          <tr key={orderItem.id}>
                            <td>{orderItem.product_name}</td>
                            <td>{orderItem.buy_price}</td>
                            <td><input className='form-control form-control-sm' type="number" value={orderItem.product_quantity} onChange={(e) => handleQuantityChange(index, e.target.value)} /></td>
                            <td><button className='btn btn-danger btn-sm' onClick={() => removeFromOrderList(orderItem.id)}><i className="fa-regular fa-trash-can"></i></button></td>
                            <td>{orderItem.buy_price * orderItem.product_quantity}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={5} className={style.emptyListText}>ORDER LIST EMPTY</td>
                        </tr>
                      )}

                    </tbody>
                    <tfoot>
                      <tr>
                        <th colSpan={4} className='text-end'>Estimated Order Price</th>
                        <th>{orderList.reduce((total, item) => total + item.buy_price * item.product_quantity, 0)}</th>
                      </tr>
                      <tr className='m-0 p-0'>
                        <th className='p-0 m-0' onClick={addOrder} colSpan={5}><button type="button" className={`m-0 ${style.submitButton}`}><i className="fa-solid fa-plus"></i> ADD ORDER</button></th>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

    </div >



  )
}

export default AddSupplierOrder
